(() => {
  const SELECTOR = '[data-rd-newsletter-system]';
  const GLOBAL_INIT = '__rdNewsletterSystemInit';

  if (typeof window[GLOBAL_INIT] === 'function') {
    window[GLOBAL_INIT]();
    return;
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSystem);
  }

  function initSystem(root) {
    if (!root || root.dataset.rdInitialized === 'true') return;
    root.dataset.rdInitialized = 'true';

    const sectionId = root.dataset.sectionId || 'default';

    const popup = root.querySelector('[data-rd-popup]');
    const dialog = popup?.querySelector('[data-rd-popup-dialog]');
    const popupClose = popup?.querySelector('[data-rd-popup-close]');
    const popupOverlay = popup?.querySelector('[data-rd-popup-overlay]');
    const formSlot = popup?.querySelector('[data-rd-form-slot]');
    let popupHeading = popup?.querySelector('.rd-newsletter-popup__heading');
    let popupSubheading = popup?.querySelector('.rd-newsletter-popup__subheading');

    const reminder = root.querySelector('[data-rd-reminder]');
    const reminderButton = reminder?.querySelector('[data-rd-reminder-button]');
    const reminderText = reminder?.querySelector('.rd-newsletter-reminder__text');

    const success = root.querySelector('[data-rd-success]');
    const successDialog = success?.querySelector('[data-rd-success-dialog]');
    const successOverlay = success?.querySelector('[data-rd-success-overlay]');
    const successCloseButtons = success ? [...success.querySelectorAll('[data-rd-success-close]')] : [];
    const successHeading = success?.querySelector('[data-rd-success-heading]');
    const successMessage = success?.querySelector('[data-rd-success-message]');
    const successDiscount = success?.querySelector('[data-rd-success-discount]');
    const discountLabel = success?.querySelector('[data-rd-success-discount-label]');
    const discountNote = success?.querySelector('[data-rd-success-discount-note]');
    const discountCode = success?.querySelector('[data-rd-discount-code]');
    const discountCopy = success?.querySelector('[data-rd-copy-code]');
    const marketOffers = success ? [...success.querySelectorAll('[data-rd-market-offer]')] : [];

    if (!popup) return;

    const triggerMode = root.dataset.trigger || 'both';
    const delaySeconds = Math.max(0, Number(root.dataset.delay || 12));
    const exitArmSeconds = Math.max(0, Number(root.dataset.exitArm || 5));
    const exitTopThreshold = Math.min(40, Math.max(0, Number(root.dataset.exitThreshold || 12)));
    const exitIgnoreDismissal = root.dataset.exitIgnoreDismissal !== 'false';
    const exitOncePerSession = root.dataset.exitOnceSession !== 'false';
    const mobileReturnEnabled = root.dataset.mobileReturn !== 'false';
    const mobileReturnArmSeconds = Math.max(0, Number(root.dataset.mobileReturnArm || 15));
    const mobileReturnAwaySeconds = Math.max(0, Number(root.dataset.mobileReturnAway || 8));
    const mobileReturnIgnoreDismissal = root.dataset.mobileReturnIgnoreDismissal !== 'false';
    const mobileReturnOncePerSession = root.dataset.mobileReturnOnceSession !== 'false';
    const frequency = root.dataset.frequency || '7_days';
    const formId = (root.dataset.formId || 'default').trim();
    const successMarker = (root.dataset.successMarker || '').trim().toLowerCase();
    const allowOverlayClose = root.dataset.overlayClose === 'true';
    const allowEscapeClose = root.dataset.escapeClose === 'true';
    const lockScroll = root.dataset.lockScroll === 'true';
    const serverSubscribed = root.dataset.serverSubscribed === 'true';
    const designMode = root.dataset.designMode === 'true' || Boolean(window.Shopify && Shopify.designMode);

    const storageKey = `rd_newsletter_${sectionId}`;
    const subscribedKey = `rd_newsletter_subscribed_${formId || 'default'}`;
    const exitSessionKey = `rd_newsletter_exit_shown_${formId || sectionId}`;
    const mobileReturnSessionKey = `rd_newsletter_mobile_return_shown_${formId || sectionId}`;
    const initializedAt = Date.now();

    let popupOpen = false;
    let successOpen = false;
    let successHandled = false;
    let exitIntentArmed = false;
    let exitTriggeredThisPage = false;
    let mobileHiddenAt = 0;
    let mobileReturnTriggeredThisPage = false;
    let delayTimer = null;
    let armTimer = null;
    let reminderTimer = null;
    let previousActive = null;
    let successPreviousActive = null;
    let originalBodyOverflow = '';
    let pageLocked = false;
    let formObserver = null;
    let submissionPending = false;
    let submissionStartedAt = 0;
    let preSubmitSnapshot = null;
    let successCandidateSince = 0;
    let successPollTimer = null;
    let activeFormHost = formSlot;
    let activeMarketForm = null;
    const successCheckTimers = [];
    const styleTimers = [];

    const observedShadowRoots = new WeakSet();
    const styledShadowRoots = new WeakSet();
    const birthdayInputsEnhanced = new WeakSet();
    const shadowCleanups = [];

    function ensurePopupOfferTargets() {
      const inner = popup?.querySelector('.rd-newsletter-popup__inner');
      if (!inner) return;

      if (!popupSubheading) {
        popupSubheading = document.createElement('div');
        popupSubheading.id = `rd-newsletter-popup-description-${sectionId}`;
        popupSubheading.className = 'rd-newsletter-popup__subheading rte';
        popupSubheading.hidden = true;
        inner.insertBefore(popupSubheading, formSlot || null);
      }

      if (!popupHeading) {
        popupHeading = document.createElement('h2');
        popupHeading.id = `rd-newsletter-popup-heading-${sectionId}`;
        popupHeading.className = 'rd-newsletter-popup__heading';
        popupHeading.hidden = true;
        inner.insertBefore(popupHeading, popupSubheading);
      }
    }

    ensurePopupOfferTargets();

    const offerTargets = [
      popupHeading,
      popupSubheading,
      reminderText,
      successHeading,
      successMessage,
      discountCode,
      discountLabel,
      discountNote
    ].filter(Boolean);

    const offerDefaults = new Map(
      offerTargets.map(target => [target, {
        html: target.innerHTML,
        hidden: target.hidden
      }])
    );

    function restoreOfferTarget(target) {
      const fallback = offerDefaults.get(target);
      if (!target || !fallback) return;
      target.innerHTML = fallback.html;
      target.hidden = fallback.hidden;
    }

    function offerSource(offer, selector) {
      return offer?.querySelector(selector) || null;
    }

    function applyMarkupOverride(target, offer, selector) {
      if (!target) return;
      const source = offerSource(offer, selector);
      const markup = (source?.innerHTML || '').trim();

      if (!markup) {
        restoreOfferTarget(target);
        return;
      }

      target.innerHTML = markup;
      target.hidden = false;
    }

    function applyTextOverride(target, offer, selector) {
      if (!target) return;
      const source = offerSource(offer, selector);
      const value = (source?.textContent || '').trim();

      if (!value) {
        restoreOfferTarget(target);
        return;
      }

      target.textContent = value;
      target.hidden = false;
    }

    function hasText(target) {
      return Boolean((target?.textContent || '').trim());
    }

    function syncOfferAccessibility() {
      if (popupHeading) {
        popupHeading.hidden = !hasText(popupHeading);
        if (!popupHeading.hidden) dialog?.setAttribute('aria-labelledby', popupHeading.id);
        else dialog?.removeAttribute('aria-labelledby');
      }

      if (popupSubheading) {
        popupSubheading.hidden = !hasText(popupSubheading);
        if (!popupSubheading.hidden) dialog?.setAttribute('aria-describedby', popupSubheading.id);
        else dialog?.removeAttribute('aria-describedby');
      }

      if (successHeading) {
        successHeading.hidden = !hasText(successHeading);
        if (!successHeading.hidden) successDialog?.setAttribute('aria-labelledby', successHeading.id);
        else successDialog?.removeAttribute('aria-labelledby');
      }

      if (successMessage) {
        successMessage.hidden = !hasText(successMessage);
        if (!successMessage.hidden) successDialog?.setAttribute('aria-describedby', successMessage.id);
        else successDialog?.removeAttribute('aria-describedby');
      }

      if (discountLabel) discountLabel.hidden = !hasText(discountLabel);
      if (discountNote) discountNote.hidden = !hasText(discountNote);
      if (successDiscount) successDiscount.hidden = !hasText(discountCode);
    }

    function applyMarketOffer(offer = null, { includeFormCopy = true } = {}) {
      applyMarkupOverride(popupHeading, offer, '[data-rd-offer-popup-heading]');
      applyMarkupOverride(popupSubheading, offer, '[data-rd-offer-popup-subheading]');
      applyTextOverride(reminderText, offer, '[data-rd-offer-reminder-text]');
      applyMarkupOverride(successHeading, offer, '[data-rd-offer-success-heading]');
      applyMarkupOverride(successMessage, offer, '[data-rd-offer-success-message]');
      applyTextOverride(discountCode, offer, '[data-rd-offer-discount-code]');
      applyTextOverride(discountLabel, offer, '[data-rd-offer-discount-label]');
      applyTextOverride(discountNote, offer, '[data-rd-offer-discount-note]');
      if (includeFormCopy) applyMarketFormCopy();
      syncOfferAccessibility();
    }

    function applyMarketFormCopy() {
      if (!activeMarketForm) return;

      [
        [popupHeading, '[data-rd-market-popup-heading]'],
        [popupSubheading, '[data-rd-market-popup-subheading]'],
        [reminderText, '[data-rd-market-reminder-text]', true],
        [successHeading, '[data-rd-market-success-heading]'],
        [successMessage, '[data-rd-market-success-message]']
      ].forEach(([target, selector, textOnly = false]) => {
        const source = activeMarketForm.querySelector(selector);
        const text = (source?.content?.textContent || source?.textContent || '').trim();
        if (!target || !text) return;

        if (textOnly) target.textContent = text;
        else target.innerHTML = source.innerHTML;
        target.hidden = false;
      });
    }

    function selectedMarketOffer() {
      return marketOffers.find(offer => (
        offer.dataset.rdMarketEnabled !== 'false' &&
        offer.dataset.rdMarketMatch === 'true'
      )) || null;
    }

    function marketFormElements() {
      return formSlot ? [...formSlot.querySelectorAll('[data-rd-market-form]')] : [];
    }

    function topLevelFormHost(node) {
      if (!formSlot || !node || !formSlot.contains(node)) return null;
      let host = node;

      while (host.parentElement && host.parentElement !== formSlot) {
        host = host.parentElement;
      }

      return host.parentElement === formSlot ? host : null;
    }

    function formHostCandidates(marketForms = marketFormElements()) {
      if (!formSlot) return { marketHosts: new Map(), fallbackHosts: [] };

      const marketHosts = new Map();
      marketForms.forEach(marketForm => {
        const host = topLevelFormHost(marketForm);
        if (host) marketHosts.set(marketForm, host);
      });

      const marketHostSet = new Set(marketHosts.values());
      const fallbackHosts = [...formSlot.children].filter(child => (
        !marketHostSet.has(child) &&
        !['STYLE', 'SCRIPT', 'TEMPLATE'].includes(child.tagName)
      ));

      return { marketHosts, fallbackHosts };
    }

    function selectedMarketForm(marketForms = marketFormElements()) {
      return marketForms.find(marketForm => (
        marketForm.dataset.rdMarketFormEnabled !== 'false' &&
        marketForm.dataset.rdMarketFormMatch === 'true'
      )) || null;
    }

    function activateMarketForm({ marketForm, fallbackHost, forceFallback = false } = {}) {
      if (!formSlot) {
        activeFormHost = null;
        return null;
      }

      const marketForms = marketFormElements();
      const { marketHosts, fallbackHosts } = formHostCandidates(marketForms);
      const selected = forceFallback ? null : (marketForm || selectedMarketForm(marketForms));
      const selectedHost = selected ? marketHosts.get(selected) : null;
      const activeHost = selectedHost || fallbackHost || fallbackHosts[0] || null;
      const allHosts = new Set([...marketHosts.values(), ...fallbackHosts]);

      allHosts.forEach(host => {
        host.hidden = Boolean(activeHost && host !== activeHost);
        host.setAttribute('aria-hidden', host.hidden ? 'true' : 'false');
      });

      activeFormHost = activeHost || formSlot;
      activeMarketForm = selectedHost ? selected : null;
      formSlot.dataset.rdActiveMarketForm = activeMarketForm?.dataset.rdMarketFormName || 'default';
      formSlot.dataset.rdFormSelectionReady = 'true';
      return activeMarketForm;
    }

    function countryCodeSet(value) {
      return new Set(
        String(value || '')
          .toUpperCase()
          .split(/[;,|]/)
          .map(code => code.trim())
          .filter(Boolean)
      );
    }

    function marketOfferForForm(marketForm) {
      if (!marketForm) return null;
      const formCountries = countryCodeSet(marketForm.dataset.rdMarketFormCountries);
      if (!formCountries.size) return null;

      return marketOffers.find(offer => {
        if (offer.dataset.rdMarketEnabled === 'false') return false;
        const offerCountries = countryCodeSet(offer.dataset.rdMarketCountries);
        return [...formCountries].some(code => offerCountries.has(code));
      }) || null;
    }

    let activeMarketOffer = selectedMarketOffer();
    activeMarketForm = activateMarketForm();
    applyMarketOffer(activeMarketOffer);

    function frequencyMs(value) {
      switch (value) {
        case 'session': return 0;
        case '1_day': return 86400000;
        case '3_days': return 259200000;
        case '7_days': return 604800000;
        case '14_days': return 1209600000;
        case '30_days': return 2592000000;
        case 'never': return Number.POSITIVE_INFINITY;
        default: return 604800000;
      }
    }

    function exitAlreadyShownThisSession() {
      if (!exitOncePerSession || designMode) return false;
      try {
        return sessionStorage.getItem(exitSessionKey) === 'true';
      } catch (_) {
        return false;
      }
    }

    function markExitShownThisSession() {
      if (!exitOncePerSession || designMode) return;
      try {
        sessionStorage.setItem(exitSessionKey, 'true');
      } catch (_) {}
    }

    function addExitIntentListeners() {
      document.addEventListener('mouseout', handleExitIntent);
      document.documentElement.addEventListener('mouseleave', handleExitIntent);
    }

    function removeExitIntentListeners() {
      document.removeEventListener('mouseout', handleExitIntent);
      document.documentElement.removeEventListener('mouseleave', handleExitIntent);
    }

    function isMobileReturnDevice() {
      return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    }

    function mobileReturnAlreadyShownThisSession() {
      if (!mobileReturnOncePerSession || designMode) return false;
      try {
        return sessionStorage.getItem(mobileReturnSessionKey) === 'true';
      } catch (_) {
        return false;
      }
    }

    function markMobileReturnShownThisSession() {
      if (!mobileReturnOncePerSession || designMode) return;
      try {
        sessionStorage.setItem(mobileReturnSessionKey, 'true');
      } catch (_) {}
    }

    function recordMobileHidden() {
      if (!mobileReturnEnabled || designMode || !isMobileReturnDevice() || isSubscribed()) return;
      if ((Date.now() - initializedAt) < mobileReturnArmSeconds * 1000) {
        mobileHiddenAt = 0;
        return;
      }

      if (!mobileHiddenAt) mobileHiddenAt = Date.now();
    }

    function showMobileReturnPopup() {
      if (!mobileHiddenAt) return;

      const timeAway = Date.now() - mobileHiddenAt;
      mobileHiddenAt = 0;

      if (timeAway < mobileReturnAwaySeconds * 1000) return;
      if (
        !mobileReturnEnabled ||
        designMode ||
        !isMobileReturnDevice() ||
        mobileReturnTriggeredThisPage ||
        popupOpen ||
        successOpen ||
        isSubscribed() ||
        mobileReturnAlreadyShownThisSession()
      ) return;
      if (!mobileReturnIgnoreDismissal && shouldSuppressPopup()) return;

      mobileReturnTriggeredThisPage = true;
      markMobileReturnShownThisSession();
      showPopup({ force: mobileReturnIgnoreDismissal });
    }

    function handleVisibilityChange() {
      if (document.visibilityState === 'hidden') recordMobileHidden();
      else if (document.visibilityState === 'visible') showMobileReturnPopup();
    }

    function handlePageShow() {
      if (document.visibilityState !== 'hidden') showMobileReturnPopup();
    }

    function addMobileReturnListeners() {
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('pagehide', recordMobileHidden);
      window.addEventListener('pageshow', handlePageShow);
    }

    function removeMobileReturnListeners() {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pagehide', recordMobileHidden);
      window.removeEventListener('pageshow', handlePageShow);
    }

    function isSubscribed() {
      if (designMode) return false;
      if (serverSubscribed) return true;
      try {
        return localStorage.getItem(subscribedKey) === 'true';
      } catch (_) {
        return false;
      }
    }

    function markSubscribed() {
      if (!designMode) {
        try { localStorage.setItem(subscribedKey, 'true'); } catch (_) {}
      }
      hideReminder();
      if (delayTimer) clearTimeout(delayTimer);
      if (armTimer) clearTimeout(armTimer);
      exitIntentArmed = false;
      removeExitIntentListeners();
      removeMobileReturnListeners();
    }

    function shouldSuppressPopup() {
      if (designMode) return false;
      if (isSubscribed()) return true;

      try {
        if (frequency === 'session') {
          return sessionStorage.getItem(storageKey) === 'closed';
        }

        const raw = localStorage.getItem(storageKey);
        if (!raw) return false;
        const saved = JSON.parse(raw);
        if (!saved?.closedAt) return false;
        if (frequency === 'never') return true;
        return (Date.now() - Number(saved.closedAt)) < frequencyMs(frequency);
      } catch (_) {
        return false;
      }
    }

    function recordDismissal() {
      if (designMode) return;
      try {
        localStorage.setItem(storageKey, JSON.stringify({ closedAt: Date.now() }));
        if (frequency === 'session') sessionStorage.setItem(storageKey, 'closed');
      } catch (_) {}
    }

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    function focusables(container) {
      if (!container) return [];
      const items = [];

      const scan = scope => {
        [...(scope.children || [])].forEach(el => {
          if (
            el.matches?.(focusableSelector) &&
            el.getAttribute('aria-hidden') !== 'true' &&
            isVisible(el)
          ) {
            items.push(el);
          }

          if (el.shadowRoot) scan(el.shadowRoot);
          scan(el);
        });
      };

      scan(container);
      return items;
    }

    function deepActiveElement() {
      let active = document.activeElement;
      while (active?.shadowRoot?.activeElement) {
        active = active.shadowRoot.activeElement;
      }
      return active;
    }

    function lockPage() {
      if (!lockScroll || pageLocked) return;
      originalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      pageLocked = true;
    }

    function unlockPage() {
      if (!lockScroll || !pageLocked) return;
      document.body.style.overflow = originalBodyOverflow;
      pageLocked = false;
    }

    function showPopup({ force = false } = {}) {
      if (!popup || popupOpen || successOpen || isSubscribed()) return;
      if (!force && shouldSuppressPopup()) return;

      hideReminder();
      styleForms();
      popupOpen = true;
      previousActive = deepActiveElement();
      popup.dataset.open = 'true';
      popup.setAttribute('aria-hidden', 'false');
      lockPage();

      requestAnimationFrame(() => {
        const items = focusables(dialog);
        (items[0] || dialog)?.focus({ preventScroll: true });
      });
    }

    function closePopup({ remember = true, offerReminder = true, restoreFocus = true } = {}) {
      if (!popupOpen || !popup) return;

      popupOpen = false;
      popup.dataset.open = 'false';
      popup.setAttribute('aria-hidden', 'true');
      unlockPage();

      if (remember) recordDismissal();
      if (offerReminder && !isSubscribed()) showReminder();

      if (restoreFocus && previousActive?.focus) {
        try { previousActive.focus({ preventScroll: true }); } catch (_) {}
      }
    }

    function showReminder({ immediate = false, force = false } = {}) {
      if (!reminder || !reminderButton) return;
      if (!force && (isSubscribed() || popupOpen || successOpen)) return;

      if (reminderTimer) clearTimeout(reminderTimer);
      const delay = Math.max(0, Number(reminder.dataset.delay || 1));

      const reveal = () => {
        if (!force && (isSubscribed() || popupOpen || successOpen)) return;
        reminder.dataset.visible = 'true';
        reminder.setAttribute('aria-hidden', 'false');
        reminderButton.setAttribute('tabindex', '0');
      };

      if (immediate || delay === 0) reveal();
      else reminderTimer = window.setTimeout(reveal, delay * 1000);
    }

    function hideReminder() {
      if (reminderTimer) {
        clearTimeout(reminderTimer);
        reminderTimer = null;
      }

      if (!reminder) return;
      reminder.dataset.visible = 'false';
      reminder.setAttribute('aria-hidden', 'true');
      reminderButton?.setAttribute('tabindex', '-1');
    }

    function showSuccess({ force = false } = {}) {
      if (!success || successOpen) return;
      if (!force && designMode) return;

      hideReminder();
      successOpen = true;
      successPreviousActive = deepActiveElement();
      success.dataset.open = 'true';
      success.setAttribute('aria-hidden', 'false');
      lockPage();

      requestAnimationFrame(() => {
        const items = focusables(successDialog);
        (items[0] || successDialog)?.focus({ preventScroll: true });
      });
    }

    function closeSuccess() {
      if (!successOpen || !success) return;

      successOpen = false;
      success.dataset.open = 'false';
      success.setAttribute('aria-hidden', 'true');
      unlockPage();

      if (successPreviousActive?.focus) {
        try { successPreviousActive.focus({ preventScroll: true }); } catch (_) {}
      }
    }

    function normalizeLabel(value) {
      return (value || '')
        .replace(/\*/g, '')
        .replace(/\brequired\b/gi, '')
        .replace(/\s+/g, ' ')
        .replace(/\s*:\s*$/, '')
        .trim();
    }

    function findLabel(scope, field) {
      if (field.id && scope.querySelector) {
        try {
          const escaped = window.CSS?.escape ? CSS.escape(field.id) : field.id.replace(/"/g, '\\"');
          const label = scope.querySelector(`label[for="${escaped}"]`);
          if (label) return label;
        } catch (_) {}
      }

      const wrapping = field.closest?.('label');
      if (wrapping) return wrapping;

      return field.parentElement?.querySelector?.('label') || null;
    }

    function applyPlaceholders(scope) {
      if (!scope?.querySelectorAll || popup.dataset.formLabelMode !== 'inside') return;

      const fields = scope.querySelectorAll(
        'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]), textarea'
      );

      fields.forEach(field => {
        const type = (field.getAttribute('type') || '').toLowerCase();
        if (['date', 'month', 'time', 'datetime-local'].includes(type)) return;

        const existing = (field.getAttribute('placeholder') || '').trim();
        if (/^(mm|dd|yyyy|yy|month|day|year)$/i.test(existing)) return;

        const label = findLabel(scope, field);
        const labelText = normalizeLabel(label?.textContent);
        if (!labelText) return;

        field.setAttribute('placeholder', labelText);

        if (!field.getAttribute('aria-label') && !field.getAttribute('aria-labelledby')) {
          field.setAttribute('aria-label', labelText);
        }
      });
    }

    function birthdayControl(scope, label) {
      const selector = 'input[type="number"], select, [role="combobox"], button[aria-haspopup="listbox"], button[aria-haspopup="menu"]';
      const forId = label.getAttribute?.('for');

      if (forId && scope.querySelector) {
        try {
          const escaped = window.CSS?.escape ? CSS.escape(forId) : forId.replace(/"/g, '\\"');
          const field = scope.querySelector(`#${escaped}`);
          if (field) return field.matches?.(selector) ? field : field.querySelector?.(selector);
        } catch (_) {}
      }

      if (label.control) return label.control;

      const nested = label.querySelector?.(selector);
      if (nested) return nested;

      let node = label;
      for (let depth = 0; depth < 5 && node?.parentElement; depth += 1) {
        node = node.parentElement;
        const controls = node.querySelectorAll?.(selector) || [];
        if (controls.length === 1) return controls[0];
        if (node.matches?.('form')) break;
      }

      return null;
    }

    function birthdayFieldContainer(label, control) {
      let node = label.parentElement;

      while (node && !node.matches?.('form')) {
        if (node.contains(control)) {
          const controls = node.querySelectorAll?.(
            'input[type="number"], select, [role="combobox"], button[aria-haspopup="listbox"], button[aria-haspopup="menu"]'
          );
          if (!controls || controls.length <= 1) return node;
        }
        node = node.parentElement;
      }

      return label.parentElement || control.parentElement;
    }

    function commonParent(first, second) {
      const parents = new Set();
      let node = first;

      while (node) {
        parents.add(node);
        node = node.parentElement;
      }

      node = second;
      while (node) {
        if (parents.has(node)) return node;
        node = node.parentElement;
      }

      return null;
    }

    function directChildOf(parent, child) {
      let node = child;
      while (node?.parentElement && node.parentElement !== parent) {
        node = node.parentElement;
      }
      return node?.parentElement === parent ? node : null;
    }

    function setBirthdayLabel(label, value, kind) {
      if (!label || !value) return;

      label.setAttribute('data-rd-birthday-label', kind);
      if (normalizeLabel(label.textContent).toLowerCase() !== value.toLowerCase()) {
        label.textContent = value;
      }
    }

    function refineBirthdayFields(scope) {
      if (!scope?.querySelectorAll || popup.dataset.birthdayRefinement !== 'true') return;

      const labels = [...scope.querySelectorAll(
        'label, legend, [data-testid*="label"], [class*="field-label"], [class*="fieldLabel"]'
      )];

      let day = null;
      let month = null;

      labels.forEach(label => {
        const name = normalizeLabel(label.textContent)
          .replace(/[()]/g, '')
          .replace(/\boptional\b/gi, '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

        let kind = null;
        if (/^(birth\s*)?(day|date)$/.test(name)) kind = 'day';
        if (/^(birth\s*)?month$/.test(name)) kind = 'month';
        if (!kind) return;

        const control = birthdayControl(scope, label);
        if (!control) return;

        const container = birthdayFieldContainer(label, control);
        if (!container) return;

        const result = { label, control, container };
        if (kind === 'day' && !day) day = result;
        if (kind === 'month' && !month) month = result;
      });

      if (!day || !month) return;

      const layout = commonParent(day.container, month.container);
      if (!layout || layout === day.container || layout === month.container) return;

      const dayItem = directChildOf(layout, day.container);
      const monthItem = directChildOf(layout, month.container);
      if (!dayItem || !monthItem || dayItem === monthItem) return;

      layout.setAttribute('data-rd-birthday-layout', 'true');
      dayItem.setAttribute('data-rd-birthday-field', 'day');
      monthItem.setAttribute('data-rd-birthday-field', 'month');

      const dayLabel = popup.dataset.birthdayDayLabel || 'Day';
      const monthLabel = popup.dataset.birthdayMonthLabel || 'Month';

      setBirthdayLabel(day.label, dayLabel, 'day');
      setBirthdayLabel(month.label, monthLabel, 'month');

      day.control.setAttribute('aria-label', dayLabel);
      month.control.setAttribute('aria-label', monthLabel);

      if (day.control.matches?.('input[type="number"]')) {
        day.control.setAttribute('min', '1');
        day.control.setAttribute('max', '31');
        day.control.setAttribute('step', '1');
        day.control.setAttribute('inputmode', 'numeric');
        day.control.setAttribute('autocomplete', 'bday-day');
        day.control.setAttribute('placeholder', 'DD');
        enhanceBirthdayNumberInput(day.control);
      }

      if (month.control.matches?.('input[type="number"]')) {
        month.control.setAttribute('min', '1');
        month.control.setAttribute('max', '12');
        month.control.setAttribute('step', '1');
        month.control.setAttribute('inputmode', 'numeric');
        month.control.setAttribute('autocomplete', 'bday-month');
        month.control.setAttribute('placeholder', 'MM');
        enhanceBirthdayNumberInput(month.control);
      }

      const blankDay = day.control.matches?.('select')
        ? [...day.control.options].find(option => !option.value)
        : null;
      const blankMonth = month.control.matches?.('select')
        ? [...month.control.options].find(option => !option.value)
        : null;

      if (blankDay && !normalizeLabel(blankDay.textContent)) blankDay.textContent = dayLabel;
      if (blankMonth && !normalizeLabel(blankMonth.textContent)) blankMonth.textContent = monthLabel;

      let caption = [...layout.children].find(child => child.hasAttribute?.('data-rd-birthday-caption'));

      if (!caption) {
        caption = document.createElement('div');
        caption.setAttribute('data-rd-birthday-caption', '');
        layout.insertBefore(caption, dayItem);
      }

      const captionText = popup.dataset.birthdayCaption || 'Birthday — optional';
      if (caption.textContent !== captionText) caption.textContent = captionText;
      caption.id = `rd-newsletter-birthday-${sectionId}`;

      [day.control, month.control].forEach(control => {
        const ids = new Set(
          (control.getAttribute('aria-describedby') || '')
            .split(/\s+/)
            .filter(Boolean)
        );

        ids.add(caption.id);
        control.setAttribute('aria-describedby', [...ids].join(' '));
      });
    }

    function enhanceBirthdayNumberInput(input) {
      if (!input || birthdayInputsEnhanced.has(input)) return;

      const preventNonIntegerKeys = event => {
        if (['e', 'E', '+', '-', '.', ','].includes(event.key)) {
          event.preventDefault();
        }
      };

      input.addEventListener('keydown', preventNonIntegerKeys);
      birthdayInputsEnhanced.add(input);
    }

    function shadowFormCss() {
      const d = popup.dataset;
      const hideHelp = d.hideHelp === 'true';
      const inside = d.formLabelMode === 'inside';
      const showBirthdayLabels = d.birthdayShowLabels === 'true';
      const formButtonWidthMobile = Number(d.formButtonWidthMobile || d.formButtonWidth || 240);

      return `
        :host, :host * { box-sizing: border-box; }
        :host { display:block!important; width:100%!important; max-width:100%!important; background:transparent!important; color:${d.formTextColor}!important; }
        form { width:100%!important; max-width:100%!important; margin:0!important; padding:0 1px 0 0!important; box-sizing:border-box!important; overflow:visible!important; background:transparent!important; }
        label, legend { color:${d.formLabelColor}!important; font-size:${d.formLabelSizeDesktop}px!important; line-height:1.2!important; }

        ${inside ? `
          label {
            position:absolute!important;
            width:1px!important;
            height:1px!important;
            margin:-1px!important;
            padding:0!important;
            overflow:hidden!important;
            clip:rect(0 0 0 0)!important;
            clip-path:inset(50%)!important;
            white-space:nowrap!important;
            border:0!important;
          }

          legend {
            position:static!important;
            display:block!important;
            width:100%!important;
            margin:0 0 ${d.formLabelGap}px!important;
            padding:0!important;
          }
        ` : `
          label, legend {
            position:static!important;
            display:block!important;
            width:auto!important;
            height:auto!important;
            margin:0 0 ${d.formLabelGap}px!important;
            padding:0!important;
            transform:none!important;
            background:transparent!important;
          }
        `}

        input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
        select,
        textarea,
        [role="combobox"],
        button[aria-haspopup="listbox"],
        button[aria-haspopup="menu"] {
          width:100%!important;
          max-width:100%!important;
          min-width:0!important;
          min-height:${d.formInputHeightDesktop}px!important;
          margin:0!important;
          box-sizing:border-box!important;
          border:${d.formBorderWidth}px solid ${d.formBorderColor}!important;
          border-radius:${d.formRadius}px!important;
          background:${d.formInputBackground}!important;
          color:${d.formTextColor}!important;
          box-shadow:none!important;
          outline:none!important;
          padding:0 ${d.formPaddingX}px!important;
          font-size:${d.formInputSizeDesktop}px!important;
        }

        select,
        [role="combobox"],
        button[aria-haspopup="listbox"],
        button[aria-haspopup="menu"] {
          display:flex!important;
          align-items:center!important;
          justify-content:space-between!important;
          font-family:inherit!important;
          text-align:left!important;
          cursor:pointer!important;
        }

        select option {
          background:${d.formInputBackground}!important;
          color:${d.formTextColor}!important;
        }

        [role="combobox"] *,
        button[aria-haspopup="listbox"] *,
        button[aria-haspopup="menu"] * {
          color:inherit!important;
        }

        [role="combobox"] svg,
        button[aria-haspopup="listbox"] svg,
        button[aria-haspopup="menu"] svg {
          color:${d.formFocusColor}!important;
          fill:currentColor!important;
        }

        textarea {
          min-height:110px!important;
          padding-top:12px!important;
          padding-bottom:12px!important;
        }

        input::placeholder,
        textarea::placeholder {
          color:${d.formPlaceholderColor}!important;
          opacity:1!important;
        }

        input:focus,
        select:focus,
        textarea:focus,
        [role="combobox"]:focus,
        button[aria-haspopup="listbox"]:focus,
        button[aria-haspopup="menu"]:focus {
          border-color:${d.formFocusColor}!important;
          box-shadow:0 0 0 1px ${d.formFocusColor}!important;
        }

        [role="listbox"] {
          border:${d.formBorderWidth}px solid ${d.formBorderColor}!important;
          border-radius:${d.formRadius}px!important;
          background:${d.formInputBackground}!important;
          color:${d.formTextColor}!important;
          box-shadow:0 14px 32px rgba(0,0,0,.22)!important;
        }

        [role="option"] {
          background:${d.formInputBackground}!important;
          color:${d.formTextColor}!important;
        }

        [role="option"]:hover,
        [role="option"][aria-selected="true"] {
          background:${d.formFocusColor}!important;
          color:${d.formInputBackground}!important;
        }

        fieldset {
          min-width:0!important;
          max-width:100%!important;
          margin:0!important;
          padding:0!important;
          border:0!important;
          overflow:visible!important;
        }

        fieldset > *,
        form > *,
        [role="group"] > * {
          min-width:0!important;
          max-width:100%!important;
          box-sizing:border-box!important;
        }

        abbr[title="required"],
        .required,
        [class*="required"] {
          color:${d.formRequiredColor}!important;
        }

        ${hideHelp ? `
          small,
          [class*="help"],
          [class*="description"],
          [class*="caption"],
          [data-testid*="help"],
          [data-testid*="description"] {
            display:none!important;
          }
        ` : `
          small,
          [class*="help"],
          [class*="description"],
          [class*="caption"] {
            color:${d.formHelpColor}!important;
            font-size:${d.formHelpSize}px!important;
            line-height:1.4!important;
          }
        `}

        button[type="submit"],
        input[type="submit"] {
          display:flex!important;
          align-items:center!important;
          justify-content:center!important;
          width:min(100%, ${d.formButtonWidth}px)!important;
          min-height:${d.formButtonHeight}px!important;
          margin:${d.formButtonGap}px auto 0!important;
          padding:0 24px!important;
          border:${d.formButtonBorderWidth}px solid ${d.formButtonBorder}!important;
          border-radius:${d.formButtonRadius}px!important;
          background:${d.formButtonBackground}!important;
          color:${d.formButtonText}!important;
          font-size:${d.formButtonSizeDesktop}px!important;
          font-weight:${d.formButtonWeight}!important;
          letter-spacing:${Number(d.formButtonSpacing || 0) / 100}em!important;
          text-transform:${d.formButtonUppercase === 'true' ? 'uppercase' : 'none'}!important;
          cursor:pointer!important;
          transition:background-color 180ms ease, transform 180ms ease!important;
        }

        button[type="submit"]:hover,
        input[type="submit"]:hover {
          background:${d.formButtonHover}!important;
          transform:translateY(-1px)!important;
        }

        [role="alert"],
        [class*="error"] {
          font-size:12px!important;
          line-height:1.4!important;
        }

        [data-rd-birthday-layout="true"] {
          display:grid!important;
          grid-template-columns:minmax(82px, .72fr) minmax(0, 1.28fr)!important;
          column-gap:12px!important;
          align-items:start!important;
        }

        [data-rd-birthday-layout="true"] > * {
          grid-column:1 / -1!important;
        }

        [data-rd-birthday-layout="true"] > [data-rd-birthday-field="day"] {
          grid-column:1!important;
        }

        [data-rd-birthday-layout="true"] > [data-rd-birthday-field="month"] {
          grid-column:2!important;
        }

        [data-rd-birthday-layout="true"] > :has(button[type="submit"], input[type="submit"]) {
          grid-column:1 / -1!important;
          width:100%!important;
        }

        [data-rd-birthday-layout="true"] button[type="submit"],
        [data-rd-birthday-layout="true"] input[type="submit"] {
          grid-column:1 / -1!important;
          justify-self:center!important;
          min-width:min(100%, 220px)!important;
          white-space:nowrap!important;
          line-height:1.15!important;
        }

        [data-rd-birthday-caption] {
          display:flex!important;
          align-items:center!important;
          gap:10px!important;
          width:100%!important;
          margin:2px 0 8px!important;
          color:${d.formPlaceholderColor}!important;
          font-size:11px!important;
          font-weight:500!important;
          line-height:1.2!important;
          letter-spacing:.12em!important;
          text-transform:uppercase!important;
        }

        [data-rd-birthday-caption]::after {
          content:"";
          flex:1 1 auto;
          height:1px;
          background:${d.formBorderColor}!important;
          opacity:.55;
        }

        ${showBirthdayLabels ? `
          [data-rd-birthday-label] {
            position:static!important;
            display:block!important;
            width:auto!important;
            height:auto!important;
            margin:0 0 ${d.formLabelGap}px!important;
            padding:0!important;
            overflow:visible!important;
            clip:auto!important;
            clip-path:none!important;
            white-space:normal!important;
            border:0!important;
          }
        ` : `
          [data-rd-birthday-label] {
            position:absolute!important;
            width:1px!important;
            height:1px!important;
            margin:-1px!important;
            padding:0!important;
            overflow:hidden!important;
            clip:rect(0 0 0 0)!important;
            clip-path:inset(50%)!important;
            white-space:nowrap!important;
            border:0!important;
          }
        `}

        [data-rd-birthday-field] {
          display:flex!important;
          flex-direction:column!important;
          align-items:stretch!important;
        }

        [data-rd-birthday-field] [role="combobox"],
        [data-rd-birthday-field] button[aria-haspopup="listbox"],
        [data-rd-birthday-field] button[aria-haspopup="menu"] {
          background:${d.formInputBackground}!important;
          color:${d.formTextColor}!important;
          border-color:${d.formBorderColor}!important;
        }

        [data-rd-birthday-field] input[type="number"] {
          appearance:textfield!important;
          -moz-appearance:textfield!important;
          font-variant-numeric:tabular-nums!important;
        }

        [data-rd-birthday-field] input[type="number"]::-webkit-inner-spin-button,
        [data-rd-birthday-field] input[type="number"]::-webkit-outer-spin-button {
          margin:0!important;
          appearance:none!important;
          -webkit-appearance:none!important;
        }

        @media (max-width:749px) {
          label,
          legend {
            font-size:${d.formLabelSizeMobile}px!important;
          }

          input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
          select,
          textarea,
          [role="combobox"],
          button[aria-haspopup="listbox"],
          button[aria-haspopup="menu"] {
            min-height:${d.formInputHeightMobile}px!important;
            font-size:${d.formInputSizeMobile}px!important;
          }

          button[type="submit"],
          input[type="submit"] {
            width:min(100%, ${formButtonWidthMobile}px)!important;
            min-height:${d.formButtonHeightMobile}px!important;
            font-size:${d.formButtonSizeMobile}px!important;
          }
        }
      `;
    }

    function collectShadowRoots(container) {
      const roots = [];
      if (!container) return roots;

      const scan = scope => {
        scope.querySelectorAll?.('*').forEach(element => {
          if (element.shadowRoot) {
            roots.push(element.shadowRoot);
            scan(element.shadowRoot);
          }
        });
      };

      scan(container);
      return roots;
    }

    function allFormScopes() {
      const scope = activeFormHost || formSlot;
      if (!scope) return [];
      return [scope, ...collectShadowRoots(scope)];
    }

    function isVisible(element) {
      if (!(element instanceof Element)) return false;

      const styles = getComputedStyle(element);

      return (
        styles.display !== 'none' &&
        styles.visibility !== 'hidden' &&
        Number(styles.opacity) !== 0 &&
        element.getClientRects().length > 0
      );
    }

    function formSnapshot() {
      const snapshot = {
        editableFields: 0,
        submitControls: 0,
        visibleErrors: 0
      };

      allFormScopes().forEach(scope => {
        scope.querySelectorAll?.(
          'input:not([type="hidden"]):not([type="submit"]):not([type="button"]), textarea, select'
        ).forEach(element => {
          if (isVisible(element)) snapshot.editableFields += 1;
        });

        scope.querySelectorAll?.(
          'button[type="submit"], input[type="submit"]'
        ).forEach(element => {
          if (isVisible(element)) snapshot.submitControls += 1;
        });

        scope.querySelectorAll?.(
          '[role="alert"], [aria-invalid="true"], [class*="error"], [data-testid*="error"]'
        ).forEach(element => {
          if (!isVisible(element)) return;

          if ((element.textContent || '').replace(/\s+/g, ' ').trim()) {
            snapshot.visibleErrors += 1;
          }
        });
      });

      return snapshot;
    }

    function scheduleSuccessChecks() {
      [250, 900, 1800, 3500].forEach(delay => {
        successCheckTimers.push(window.setTimeout(checkSuccess, delay));
      });
    }

    function beginSubmissionWatch() {
      if (successHandled) return;

      submissionPending = true;
      submissionStartedAt = Date.now();
      preSubmitSnapshot = formSnapshot();
      successCandidateSince = 0;

      if (successPollTimer) clearInterval(successPollTimer);

      successPollTimer = window.setInterval(() => {
        if (successHandled || !submissionPending) {
          clearInterval(successPollTimer);
          successPollTimer = null;
          return;
        }

        checkSuccess();

        if (Date.now() - submissionStartedAt > 15000) {
          clearInterval(successPollTimer);
          successPollTimer = null;
          submissionPending = false;
          preSubmitSnapshot = null;
          successCandidateSince = 0;
        }
      }, 250);
    }

    function formTransitionLooksSuccessful() {
      if (!submissionPending || !preSubmitSnapshot) return false;

      const current = formSnapshot();

      if (current.visibleErrors > 0) {
        successCandidateSince = 0;
        return false;
      }

      const formWasInteractive =
        preSubmitSnapshot.editableFields > 0 ||
        preSubmitSnapshot.submitControls > 0;

      if (!formWasInteractive) return false;

      const interactiveFormGone =
        current.editableFields === 0 &&
        current.submitControls === 0;

      if (!interactiveFormGone) {
        successCandidateSince = 0;
        return false;
      }

      if (!successCandidateSince) {
        successCandidateSince = Date.now();
        return false;
      }

      return (
        Date.now() - submissionStartedAt >= 600 &&
        Date.now() - successCandidateSince >= 600
      );
    }

    function styleForms() {
      const scope = activeFormHost || formSlot;
      if (!scope) return;

      applyPlaceholders(scope);
      refineBirthdayFields(scope);

      collectShadowRoots(scope).forEach(shadowRoot => {
        applyPlaceholders(shadowRoot);
        refineBirthdayFields(shadowRoot);

        if (!styledShadowRoots.has(shadowRoot)) {
          const style = document.createElement('style');
          style.setAttribute('data-rd-form-style', sectionId);
          style.textContent = shadowFormCss();
          shadowRoot.appendChild(style);
          styledShadowRoots.add(shadowRoot);
        }

        if (observedShadowRoots.has(shadowRoot)) return;

        const observer = new MutationObserver(() => {
          applyPlaceholders(shadowRoot);
          refineBirthdayFields(shadowRoot);
          checkSuccess();
        });

        const onShadowSubmit = () => {
          beginSubmissionWatch();
          scheduleSuccessChecks();
        };

        const onShadowClick = event => {
          const submitControl = event.target?.closest?.(
            'button[type="submit"], input[type="submit"]'
          );

          if (submitControl) beginSubmissionWatch();
        };

        observer.observe(shadowRoot, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: [
            'class',
            'style',
            'hidden',
            'aria-hidden',
            'aria-invalid',
            'disabled'
          ]
        });

        shadowRoot.addEventListener('submit', onShadowSubmit, true);
        shadowRoot.addEventListener('click', onShadowClick, true);

        shadowCleanups.push(() => {
          observer.disconnect();
          shadowRoot.removeEventListener('submit', onShadowSubmit, true);
          shadowRoot.removeEventListener('click', onShadowClick, true);
        });

        observedShadowRoots.add(shadowRoot);
      });
    }

    function scopeContainsMarker(scope) {
      if (!scope || !successMarker) return false;

      const nodes = [];
      if (scope instanceof Element) nodes.push(scope);
      scope.querySelectorAll?.('*').forEach(element => nodes.push(element));

      return nodes.some(element => {
        const value = (element.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

        return value.includes(successMarker) && isVisible(element);
      });
    }

    function successMarkerVisible() {
      const scope = activeFormHost || formSlot;
      if (!scope || !successMarker) return false;

      if (scopeContainsMarker(scope)) return true;
      return collectShadowRoots(scope).some(scopeContainsMarker);
    }

    function checkSuccess() {
      if (successHandled) return true;

      const markerConfirmed = successMarkerVisible();
      const transitionConfirmed = formTransitionLooksSuccessful();

      if (!markerConfirmed && !transitionConfirmed) return false;

      successHandled = true;
      submissionPending = false;

      if (successPollTimer) {
        clearInterval(successPollTimer);
        successPollTimer = null;
      }

      markSubscribed();

      closePopup({
        remember: false,
        offerReminder: false,
        restoreFocus: false
      });

      showSuccess();
      return true;
    }

    async function copyCode() {
      if (!discountCopy || !discountCode) return;

      const code = (discountCode.textContent || '').trim();
      if (!code) return;

      const normal = discountCopy.dataset.copyLabel || 'Copy Code';
      const copied = discountCopy.dataset.copiedLabel || 'Copied!';
      const duration = Math.max(
        1,
        Number(discountCopy.dataset.copiedDuration || 2)
      );

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
        } else {
          const field = document.createElement('textarea');
          field.value = code;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.select();
          document.execCommand('copy');
          field.remove();
        }

        discountCopy.textContent = copied;

        window.setTimeout(() => {
          discountCopy.textContent = normal;
        }, duration * 1000);
      } catch (_) {
        const range = document.createRange();
        range.selectNodeContents(discountCode);

        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }

    function keepFocusInside(event, container) {
      const items = focusables(container);

      if (!items.length) {
        event.preventDefault();
        container?.focus({ preventScroll: true });
        return;
      }

      const first = items[0];
      const last = items[items.length - 1];
      const active = deepActiveElement();

      if (!items.includes(active)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    }

    function trapKeyboard(event) {
      if (successOpen) {
        if (event.key === 'Escape' && allowEscapeClose) {
          event.preventDefault();
          closeSuccess();
          return;
        }

        if (event.key !== 'Tab') return;
        keepFocusInside(event, successDialog);
        return;
      }

      if (!popupOpen) return;

      if (event.key === 'Escape' && allowEscapeClose) {
        event.preventDefault();
        closePopup();
        return;
      }

      if (event.key !== 'Tab') return;
      keepFocusInside(event, dialog);
    }

    function handleExitIntent(event) {
      if (
        !exitIntentArmed ||
        exitTriggeredThisPage ||
        popupOpen ||
        successOpen ||
        isSubscribed()
      ) return;

      if (event.sourceCapabilities?.firesTouchEvents) return;
      if (exitAlreadyShownThisSession()) return;
      if (!exitIgnoreDismissal && shouldSuppressPopup()) return;

      const leftThroughBrowserTop =
        event.clientY <= exitTopThreshold &&
        !event.relatedTarget &&
        !event.toElement;

      if (!leftThroughBrowserTop) return;

      exitTriggeredThisPage = true;
      exitIntentArmed = false;

      markExitShownThisSession();
      removeExitIntentListeners();
      showPopup({ force: exitIgnoreDismissal });
    }

    popupClose?.addEventListener('click', () => closePopup());

    if (allowOverlayClose) {
      popupOverlay?.addEventListener('click', () => closePopup());
    }

    reminderButton?.addEventListener('click', () => {
      hideReminder();
      showPopup({ force: true });
    });

    successCloseButtons.forEach(button => {
      button.addEventListener('click', closeSuccess);
    });

    successOverlay?.addEventListener('click', () => {
      if (success?.dataset.closeOverlay === 'true') closeSuccess();
    });

    discountCopy?.addEventListener('click', copyCode);
    document.addEventListener('keydown', trapKeyboard);

    const onFormSubmit = () => {
      beginSubmissionWatch();
      scheduleSuccessChecks();
    };

    const onFormClick = event => {
      const submitControl = event.target?.closest?.(
        'button[type="submit"], input[type="submit"]'
      );

      if (submitControl) beginSubmissionWatch();
    };

    if (formSlot) {
      formObserver = new MutationObserver(() => {
        if (
          activeFormHost !== formSlot &&
          !formSlot.contains(activeFormHost)
        ) {
          activeMarketForm = activateMarketForm();
          activeMarketOffer = selectedMarketOffer();
          applyMarketOffer(activeMarketOffer);
        }

        styleForms();
        checkSuccess();
      });

      formObserver.observe(formSlot, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: [
          'class',
          'style',
          'hidden',
          'aria-hidden',
          'aria-invalid',
          'disabled'
        ]
      });

      formSlot.addEventListener('submit', onFormSubmit, true);
      formSlot.addEventListener('click', onFormClick, true);

      styleForms();

      [300, 900, 1800].forEach(delay => {
        styleTimers.push(window.setTimeout(styleForms, delay));
      });
    }

    if (designMode) {
      if (popup) {
        showPopup({ force: true });
      } else {
        // RD Landing Page Chrome / enable_popup off: nothing to open in the
        // editor either, so reveal the reminder immediately for editing.
        showReminder({ immediate: true, force: true });
      }
    } else if (!isSubscribed()) {
      if (mobileReturnEnabled) addMobileReturnListeners();

      if (triggerMode === 'delay' || triggerMode === 'both') {
        delayTimer = setTimeout(() => {
          delayTimer = null;
          showPopup();
        }, delaySeconds * 1000);
      }

      if (triggerMode === 'exit' || triggerMode === 'both') {
        armTimer = setTimeout(() => {
          armTimer = null;

          if (isSubscribed() || exitAlreadyShownThisSession()) return;

          exitIntentArmed = true;
          addExitIntentListeners();
        }, exitArmSeconds * 1000);
      }

      if (!popup || shouldSuppressPopup()) {
        // No popup to open (hidden via its own checkbox, the global landing-
        // page toggle, or enable_popup being off) — or it would just be
        // suppressed by the frequency/dismissal rules anyway. Either way,
        // there's no "close" event coming to reveal the reminder normally,
        // so show it immediately instead of waiting forever.
        if (delayTimer) clearTimeout(delayTimer);
        showReminder({ immediate: true });
      }
    }

    const onBlockSelect = event => {
      if (!root.contains(event.target)) return;

      const selectedOffer =
        event.target.closest?.('[data-rd-market-offer]') ||
        event.target.querySelector?.('[data-rd-market-offer]');

      if (selectedOffer) {
        activeMarketOffer = selectedOffer;
        applyMarketOffer(activeMarketOffer, { includeFormCopy: false });
        hideReminder();

        closePopup({
          remember: false,
          offerReminder: false,
          restoreFocus: false
        });

        showSuccess({ force: true });
        return;
      }

      const selectedForm =
        event.target.closest?.('[data-rd-market-form]') ||
        event.target.querySelector?.('[data-rd-market-form]');

      if (selectedForm) {
        activeMarketForm = activateMarketForm({
          marketForm: selectedForm
        });

        activeMarketOffer = marketOfferForForm(activeMarketForm);
        applyMarketOffer(activeMarketOffer);
        styleForms();
        hideReminder();
        closeSuccess();
        showPopup({ force: true });
        return;
      }

      const selectedFormHost = topLevelFormHost(event.target);

      if (
        selectedFormHost &&
        !selectedFormHost.querySelector?.('[data-rd-market-form]')
      ) {
        activeMarketForm = activateMarketForm({
          fallbackHost: selectedFormHost,
          forceFallback: true
        });

        activeMarketOffer = null;
        applyMarketOffer(null);
        styleForms();
        hideReminder();
        closeSuccess();
        showPopup({ force: true });
        return;
      }

      activeMarketForm = activateMarketForm();
      activeMarketOffer = selectedMarketOffer();

      applyMarketOffer(activeMarketOffer);
      styleForms();

      const target =
        event.target.closest?.(
          '[data-rd-popup], [data-rd-reminder], [data-rd-success]'
        ) || event.target;

      if (target.matches?.('[data-rd-reminder]')) {
        closePopup({
          remember: false,
          offerReminder: false
        });

        closeSuccess();
        showReminder({
          immediate: true,
          force: true
        });
      } else if (target.matches?.('[data-rd-success]')) {
        hideReminder();

        closePopup({
          remember: false,
          offerReminder: false,
          restoreFocus: false
        });

        showSuccess({ force: true });
      } else if (target.matches?.('[data-rd-popup]')) {
        hideReminder();
        closeSuccess();
        showPopup({ force: true });
      }
    };

    const onSectionUnload = event => {
      if (event.detail?.sectionId !== sectionId) return;

      if (delayTimer) clearTimeout(delayTimer);
      if (armTimer) clearTimeout(armTimer);
      if (reminderTimer) clearTimeout(reminderTimer);

      if (successPollTimer) {
        clearInterval(successPollTimer);
      }

      successCheckTimers.forEach(clearTimeout);
      styleTimers.forEach(clearTimeout);
      shadowCleanups.splice(0).forEach(cleanup => cleanup());

      formObserver?.disconnect();
      formSlot?.removeEventListener('submit', onFormSubmit, true);
      formSlot?.removeEventListener('click', onFormClick, true);

      document.removeEventListener('keydown', trapKeyboard);
      removeExitIntentListeners();
      removeMobileReturnListeners();
      document.removeEventListener('shopify:block:select', onBlockSelect);
      document.removeEventListener('shopify:section:unload', onSectionUnload);

      unlockPage();
    };

    document.addEventListener('shopify:block:select', onBlockSelect);
    document.addEventListener('shopify:section:unload', onSectionUnload);
  }

  window[GLOBAL_INIT] = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, {
      once: true
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
